import { $ } from './../helpers/query'
import { gsap } from 'gsap'
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

export default class {
  constructor() {
    this.anchorAttr = 'data-scroll-to';
    this.links = $(`[${this.anchorAttr}]`);
    gsap.registerPlugin(ScrollToPlugin);
  }

  bindEvents() {
    this.links.each(link => {
      link.addEventListener('click', (e) => {
        if (document.documentElement.clientWidth < 640) {
          e.preventDefault()
          this.scrollTo(link)
        }
      })
    })
  }

  scrollTo(link) {
    const targetSel = link.getAttribute(this.anchorAttr);
    gsap.to(window, {
      duration: 1,
      scrollTo: targetSel
    })
  }
}
